var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('row-action',{attrs:{"icon":"TrashIcon","label":_vm.label || _vm.$t('foundation.rowDelete'),"danger":true}})}
var staticRenderFns = []

export { render, staticRenderFns }